import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useLazyQuery } from '@grandvisionhq/graphql';
import { useIntl } from '@grandvisionhq/state';
import '../../queries/book-appointment.js';
import '../../queries/book-appointment-by-id.js';
import '../../queries/get-availability-stores-nearby.js';
import '../../queries/get-user.js';
import '../../queries/get-calendar-availability.js';
import '../../queries/get-calendar-availablility-by-id.js';
import '../../queries/get-store-offer-by-code.js';
import { GET_STORE_OFFER_BY_ID } from '../../queries/get-store-offer-by-id.js';
import '../../queries/get-store-opening-times.js';
import '../../queries/get-store-opening-times-by-id.js';
import '../../queries/get-time-slots.js';
import '../../queries/get-time-slots-by-id.js';
import '@grandvisionhq/stores-v2';
import { fromStoreOfferByIdQueryToStore } from './adapters/fromStoreOfferByIdQueryToStore.js';

const useStoreOfferById = (variables)=>{
    const { locale  } = useIntl();
    const [query, queryState] = useLazyQuery(GET_STORE_OFFER_BY_ID, {
        variables,
        context: {
            forwardHeaders: {
                'Accept-Language': locale
            }
        }
    });
    const data = React.useMemo(()=>{
        var ref;
        return ((ref = queryState.data) === null || ref === void 0 ? void 0 : ref.store) ? fromStoreOfferByIdQueryToStore(queryState.data.store) : null;
    }, [
        queryState
    ]);
    return React.useMemo(()=>[
            query,
            swcHelpers.objectSpread({}, queryState, {
                data
            }), 
        ]
    , [
        data,
        queryState,
        query
    ]);
};

export { useStoreOfferById as default };
//# sourceMappingURL=use-store-offer-by-id.js.map
